import React from "react";

export function PageHeader({ title, subtitle, actions, testid }) {
    return (
        <div className="h-16 border-b border-zinc-200 bg-white px-8 flex items-center justify-between" data-testid={testid}>
            <div>
                <h1 className="text-lg font-semibold tracking-tight">{title}</h1>
                {subtitle && <p className="text-xs text-zinc-500 mt-0.5">{subtitle}</p>}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
    );
}

export function Container({ children }) {
    return <div className="p-6 sm:p-8 max-w-[1400px]">{children}</div>;
}
